import * as Sentry from '@sentry/angular';

import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { environment } from 'src/environments/environment';

Sentry.init({
  dsn: 'https://9c7eb27ef5cc8f8575cbe77d9421cfe4@o4508852223737856.ingest.us.sentry.io/4509677849608192',
  release: `sparket-app@${environment.version}`,
  environment: environment.production ? 'production' : 'sandbox',
  dist: `${environment.build}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.production ? 0.05 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/play\.clinch\.gg\//],
  debug: false,
});

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
